// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import { useBackButton } from '../hooks/useBackButton';

/**
 * Renders nothing — hooks into the native back button on Capacitor.
 *
 * I136: lives here rather than in main.tsx. An entry file that defines a component
 * without exporting it defeats React Fast Refresh for the whole module
 * (react-refresh/only-export-components).
 */
export default function NativeBackButton() {
  useBackButton();
  return null;
}
